import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';

import Auth from '@aws-amplify/auth';

//import Home from '../views/Home.vue';

///login
import Login from '../views/login/Login.vue';
import Forget from '../views/login/Forget.vue';
import Mail from '../views/login/Mail.vue';

//app/project
import ProjectList from '../views/app/project/List.vue';
import NewProject from '../views/app/project/New.vue';
import ProjectDetail from '../views/app/project/Detail.vue';
import ProjectEditor from '../views/app/project/Edit.vue';

//app/archive
import ArchiveList from '../views/app/archive/List.vue';
import ArchiveDetail from '../views/app/archive/Detail.vue';
import ArchiveEditor from '../views/app/archive/Edit.vue';

//app/template
import CPTemplate from '../views/app/template/Template.vue';
import CPTemplateStep01 from '../views/app/template/Step01.vue';
import CPTemplateStep02 from '../views/app/template/Step02.vue';
import CPTemplateStep03 from '../views/app/template/Step03.vue';
import CPTemplateList from '../views/app/template/TemplateList.vue';
import CPTemplateWizard from '../views/app/template/Wizard.vue';

//app/item
import Item from '../views/app/item/Item.vue';
import ItemUpload from '../views/app/item/Upload.vue';
import ItemPreview from '../views/app/item/Preview.vue';
import ItemResult from '../views/app/item/Result.vue';

//app/help
import Help from '../views/app/help/Help.vue';
import HelpEditor from '../views/app/help/Edit.vue';

//app/concept
import NewConcept from '../views/app/concept/New.vue';
import ConceptHistory from '../views/app/concept/History.vue';
import ConceptDetail from '../views/app/concept/Detail.vue';
import ConceptEdit02 from '../views/app/concept/Edit02.vue';
import ConceptGenerator from '../views/app/concept/Generator.vue';
import ConceptCompare from '../views/app/concept/Compare.vue';
import ConceptCompare01 from '../views/app/concept/Compare01.vue';
import ConceptCompare02 from '../views/app/concept/Compare02.vue';
import ConceptCompare03 from '../views/app/concept/Compare03.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login
  },
  //--login
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forget',
    name: 'Forget',
    component: Forget
  },
  {
    path: '/mailsent',
    name: 'Mail sent',
    component: Mail
  },
  //--login

  //--app/project
  // TODO: Remove [s]
  {
    path: '/project',
    name: 'Project List',
    component: ProjectList
  },
  {
    path: '/project/new',
    name: 'New Project',
    component: NewProject
  },
  {
    path: '/project/:id/detail',
    name: 'ProjectDetail',
    component: ProjectDetail,
    props: true
  },
  {
    path: '/project/:id/edit',
    name: 'ProjectEditor',
    component: ProjectEditor,
    props: true
  },
  {
    path: '/project/copy',
    name: 'Copied New Project',
    component: NewProject
  },
  //--app/project

  //--app/archive
  {
    path: '/archive',
    name: 'ArchiveList',
    component: ArchiveList
  },
  {
    path: '/archive/:id/detail',
    name: 'ArchiveDetail',
    component: ArchiveDetail,
    props: true
  },
  {
    path: '/archive/:id/edit',
    name: 'ArchiveEditor',
    component: ArchiveEditor,
    props: true
  },
  //--app/archive

  //--app/template
  {
    path: '/template',
    name: 'CP Template',
    component: CPTemplate
  },
  {
    path: '/template/step01',
    name: 'CP Template Step 1',
    component: CPTemplateStep01
  },
  {
    path: '/template/step02',
    name: 'CP Template Step 2',
    component: CPTemplateStep02
  },
  {
    path: '/template/step03',
    name: 'CP Template Step 3',
    component: CPTemplateStep03
  },
  {
    path: '/template/list',
    name: 'CP Template List',
    component: CPTemplateList
  },
  {
    path: '/template/wizard',
    name: 'CP Template Wizard',
    component: CPTemplateWizard
  },
  //--app/template

  //--app/item
  {
    path: '/item',
    name: 'Product Image',
    component: Item
  },
  {
    path: '/item/upload',
    name: 'Product Image Upload',
    component: ItemUpload
  },
  {
    path: '/item/preview',
    name: 'Product Image Preview',
    component: ItemPreview
  },
  {
    path: '/item/result',
    name: 'Product Image Result',
    component: ItemResult
  },
  //--app/item

  //--app/help
  {
    path: '/help',
    name: 'Help',
    component: Help
  },
  {
    path: '/help/edit',
    name: 'Help Editor',
    component: HelpEditor
  },
  //--app/help

  //--app/concept
  {
    path: '/concept',
    name: 'NewConcept',
    component: NewConcept,
    props: (route: Route) => ({ pid: route.query.pid })
  },
  {
    path: '/concept/history',
    name: 'ConceptHistory',
    component: ConceptHistory,
    props: (route: Route) => ({ tpid: route.query.tpid })
  },
  {
    path: '/concept/:id/detail',
    name: 'ConceptDetail',
    component: ConceptDetail,
    props: true
  },
  {
    path: '/concept/:id/edit',
    name: 'ConceptEdit',
    component: ConceptEdit02,
    props: true
  },
  {
    path: '/concept/:id/generate',
    name: 'ConceptGenerator',
    component: ConceptGenerator,
    props: true
  },
  {
    path: '/concept/compare',
    name: 'ConceptCompare',
    component: ConceptCompare,
    props: (route: Route) => ({ pid: route.query.pid })
  },
  {
    path: '/concept/compare01',
    name: 'ConceptCompare 1',
    component: ConceptCompare01
  },
  {
    path: '/concept/compare02',
    name: 'Concept Compare 2',
    component: ConceptCompare02
  },
  {
    path: '/concept/compare03',
    name: 'Concept Compare 3',
    component: ConceptCompare03
  },
  //--app/concept


  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, _from, next) => {
  Auth.currentUserPoolUser({ bypassCache: false }).then(user => {
    if (to.path === '/') {
      next({ path: '/project' });
    } else {
      next();
    }
  }).catch(err => {
    if (to.path !== '/') {
      next({ path: '/' });
    } else {
      next();
    }
  });
});

export default router;
